import React, { PureComponent } from 'react';
import { Flex, Box } from 'rebass';
import { connect } from 'unistore/react';
import ReactSelect from 'react-select';

import Actions from '~/state/Actions';
import {
  groupedOptionsSelector,
  compareOptionSelector,
} from '~/state/Selectors';
import { parseLabel } from '~/Utils';

const overwriteFontSize = (provided) => ({
  ...provided,
  fontSize: '14px',
});

const ReactSelectStyles = {
  input: overwriteFontSize,
  placeholder: overwriteFontSize,
  singleValue: overwriteFontSize,
  menu: overwriteFontSize,
  control: (provided) => ({
    ...provided,
    backgroundColor: '#fff',
  }),
};

class Controls extends PureComponent {
  render() {
    const {
      data,
      overallKey,
      setTooltipVisibility,
      setOverallKey,
      setCompareKey,
      options,
      compareValue,
    } = this.props;

    if (!data) {
      return null;
    }

    const parsedOptions = options.map((option) => {
      if (option.options) {
        option.options = option.options.map((o) => ({
          ...o,
          label: parseLabel(o.label),
        }));
      }

      return option;
    });

    return (
      <Flex pb={2} my={2} mx={-2} justifyContent="space-between">
        <Box width={1 / 2} px={2} css={{ maxWidth: 250 }}>
          <ReactSelect
            options={parsedOptions}
            isSearchable={false}
            styles={ReactSelectStyles}
            defaultValue={{
              value: overallKey,
              label: overallKey.replace(/^.*\./g, ''),
            }}
            onChange={(option) => setOverallKey(option.value)}
            onMenuOpen={() => setTooltipVisibility(false)}
            formatOptionLabel={(option) => parseLabel(option.label)}
          />
        </Box>
        <Box width={1 / 2} px={2} css={{ maxWidth: 250 }}>
          <ReactSelect
            options={parsedOptions}
            isSearchable={false}
            styles={ReactSelectStyles}
            value={compareValue}
            onChange={(option) => setCompareKey(option.value)}
            onMenuOpen={() => setTooltipVisibility(false)}
            formatOptionLabel={(option) => parseLabel(option.label)}
          />
        </Box>
      </Flex>
    );
  }
}

export default connect(
  (state) => ({
    data: state.distributionData,
    overallKey: state.overallKey,
    compareKey: state.compareKey,
    options: groupedOptionsSelector(state),
    compareValue: compareOptionSelector(state),
  }),
  Actions
)(Controls);
